<template>
  <svg
    viewBox="0 0 624.06 485.6"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid meet"
    :width="size"
    :height="size"
  >
    <defs>
      <linearGradient 
        id="linear-gradient"
        x1="6.59"
        y1="248.66"
        x2="630.65"
        y2="248.66"
        gradientUnits="userSpaceOnUse"
      >
      <stop offset="0" stop-color="#11998e"/>
      <stop offset="1" stop-color="#38ef7d"/>
      </linearGradient>
    </defs>
    <path fill="url(#linear-gradient)"
      d="M380.68,400.57l64.53,89.9,185.44-.15-157.19-219ZM630.65,6,445.21,5.86l-64.53,89.9L473.46,225ZM265.52,248.66l-43.17,60.15H6.59V188.75H222.52Zm163.28,0h22.26L276.8,491.46l-185.45-.15,131-182.5,43.17-60.15-43-59.91L91.35,6,276.8,5.86,451.06,248.64Z"
      transform="translate(-6.59 -5.86)"/>
  </svg>
</template>
<script>
export default {
  name: "Logo",
  props: {
    size: {
      type: [String, Number],
      default: "60",
    }
  }
};
</script>
